import { CookiePlusIcon } from './CookiePlusIcon';

/**
 * author: Colton Wiscombe
 * id 272BE458-B01F-4437-B083-65175B327D05
 * name cookie-plus
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-plus.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitPlusIcon = CookiePlusIcon;
export default BiscuitPlusIcon